import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const OperationsIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13.4163 10.0533C13.4033 10.8686 13.0704 11.6461 12.4893 12.218C11.9082 12.7899 11.1255 13.1105 10.3102 13.1105C9.49483 13.1105 8.71221 12.7899 8.13111 12.218C7.55001 11.6461 7.21706 10.8686 7.2041 10.0533",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.6875 10.0393V11.207L16.3525 11.474C16.1985 12.1212 15.9404 12.7391 15.5885 13.3036L16.3494 14.4376L14.7003 16.0866L13.5672 15.3257C13.0025 15.6807 12.3833 15.9405 11.7344 16.0945L11.4706 17.4224H9.14618L8.88154 16.0945C8.23284 15.9403 7.61391 15.6806 7.0495 15.3257L5.91322 16.0835L4.26417 14.4344L5.02509 13.3005C4.67286 12.736 4.41455 12.1181 4.26024 11.4708L2.92529 11.2039V10.0393",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.4163 9.57697C13.4033 8.7617 13.0704 7.98421 12.4893 7.41231C11.9082 6.8404 11.1255 6.51986 10.3102 6.51986C9.49483 6.51986 8.71221 6.8404 8.13111 7.41231C7.55001 7.98421 7.21706 8.7617 7.2041 9.57697",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.6875 9.57697V8.40928L16.3525 8.14229C16.1985 7.49507 15.9404 6.87715 15.5885 6.31262L16.3494 5.1787L14.7003 3.52965L13.5672 4.29057C13.0025 3.93555 12.3833 3.67579 11.7344 3.5218L11.4706 2.19392H9.14618L8.88154 3.5218C8.23284 3.67594 7.61391 3.93563 7.0495 4.29057L5.91322 3.53279L4.26417 5.18184L5.02509 6.31577C4.67286 6.88029 4.41455 7.49821 4.26024 8.14543L2.92529 8.41242V9.57697",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
